module.exports = __webpack_public_path__ + "static/media/login_success.0df03863.png";